/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import charity from "../assets/charity.png";
import blackStar from "../assets/shapes/black-star.png";
import greenStar from "../assets/shapes/green-star.png";
export const Branding = () => {
  return (
    <div className="relative overflow-hidden">
      {" "}
      <img
        src={greenStar}
        className="w-16 h-16 z-10 absolute left-[-1%] bottom-[10%]"
      />
      <img
        src={blackStar}
        className="w-16 h-16 z-10 absolute right-[-1%] top-[22%]"
      />
      <div className="Mhome-container relative">
        <div className="connecting">
          <h2 className="font-roboto text-3xl leading-[42px] md:text-[42px] md:leading-[60px] font-bold ">
            Together, We've Achieved Miracles
          </h2>
          <div className="home-type-body-large">
            Millions in Pakistan face hardships due to poverty, unemployment,
            and rising inflation. With your support, KWF has become a beacon of
            hope in these turbulent times, helping families survive and thrive.
          </div>
        </div>
        <div className="perfect-match flex md:flex-row flex-col items-center md:justify-end justify-center relative md:pb-4 pb-[13rem] ">
          <div className="perfect-match__left font-roboto md:w-[60%] w-[95%] md:right-[33%] right-[3%] md:top-1/3 top-[50%] absolute z-10 bg-white border-l-[14px] border-[#252A34B2] sm:pl-4 pr-2 pl-2 py-4">
            <h1 className="text-3xl leading-[42px] md:text-[42px] md:leading-[60px] !font-semibold text-justify">
              Your Donations Help Them Live a Better Life.
            </h1>
            <div className="mb-4 text-gray-600 text-sm font-normal text-justify text-gray">
              With the donations you offer, we provide the needy with groceries,
              quality education, and healthcare. We offer them groceries monthly
              to ensure no one goes hungry. Offering high-quality education to
              underprivileged children to break the cycle of poverty. Delivering
              access to quality healthcare for families who otherwise couldn't
              afford it.
            </div>
            <hr className="my-2" />
          </div>
          <div
            className="perfect-match__right md:w-1/2 w-full"
            style={{ margin: "0px" }}
          >
            <img
              src={charity}
              alt="img"
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
